<div class="h-100">
	<lib-cataloginfo-viewer
		[keypart]="'catalog-view'"
		(contactFormOpen)="openContactForm()"
		(trackMail)="trackWebEmailEvent($event)"
		(trackSocialMedia)="trackSocialMediaEvent($event)"
		[showCatalogContact]="currentViewType === viewType.Desktop"
		[catalogInfo]="model" />
</div>
